<template>

  <div class="wrapper">

    <v-row no-gutters class="box">
      <img width="20%" src="http://gamasoftware.com.br/wp-content/themes/cdx-theme/assets/img/marmovix01.png" alt="">
      <h1 style="text-align: center; margin-top: 10px" class="title">Marmovix</h1>
      <p>A sala que você está tentando acessar já foi finalizada, volte e solicite um novo atendimento.</p>
      <v-row justify="center">
        <v-icon style="main-icon" size="60" color="primary">mdi-checkbox-marked-circle-outline</v-icon>
      </v-row>
      <br>
      <v-btn block color="primary" @click="backtoForm">
        Voltar para o formulário
      </v-btn>
    </v-row>

  </div>
</template>

<script>
export default {
    name: "Room",
    data: () => ({
      name: null,
    }),
    mounted(){
      const { name } = this.$route.params;
    },
    methods: {

      backtoForm(){
        const { roomID } = this.$route.params;
        this.$router.push({name: 'Signin', params: { empID: roomID } });
      }
      
    }
}
</script>

<style lang="scss" scoped>

  .wrapper{

    .box{

      .v-btn{
        color: #272727;
        .v-progress-circular{
          margin-right: 10px;
        }
      }

      .main-icon{
        display: block;
        margin: 0 auto;
      }

      width: 25vw;
      min-width: 300px;
      display: block;
      padding: 40px 20px;

      .name{
        color: var(--v-primary-base);
        font-weight: bold;
      }
      h3{
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
      p{
        font-size: 14px;
        text-align: center;
        padding: 20px 0;
        margin: 0;
      }
      .loading{
        display: block;
        margin: 0 auto;
      }
      img{
        display: block;
        margin: 20px auto;
      }

    }
   
  }

  @media screen and (max-width: 900px) {
    .container{
      margin: 10px;
    }
   
  }

</style>